import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGeoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			rx: 4,
			fill: "#76ec71"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_828_13777)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 5.5C17.8127 5.50248 15.7157 6.37247 14.1691 7.91911C12.6225 9.46575 11.7525 11.5627 11.75 13.75C11.75 20.8094 19.25 26.1437 19.5688 26.3687C19.6965 26.4538 19.8465 26.4992 20 26.4992C20.1535 26.4992 20.3035 26.4538 20.4313 26.3687C20.75 26.1437 28.25 20.8094 28.25 13.75C28.2475 11.5627 27.3775 9.46575 25.8309 7.91911C24.2843 6.37247 22.1873 5.50248 20 5.5ZM20 10.75C20.5933 10.75 21.1734 10.9259 21.6667 11.2556C22.1601 11.5852 22.5446 12.0538 22.7716 12.6019C22.9987 13.1501 23.0581 13.7533 22.9424 14.3353C22.8266 14.9172 22.5409 15.4518 22.1213 15.8713C21.7018 16.2909 21.1672 16.5766 20.5853 16.6924C20.0033 16.8081 19.4001 16.7487 18.8519 16.5216C18.3038 16.2946 17.8352 15.9101 17.5056 15.4167C17.1759 14.9234 17 14.3433 17 13.75C17 12.9543 17.3161 12.1913 17.8787 11.6287C18.4413 11.0661 19.2044 10.75 20 10.75Z",
				fill: "#0f172b"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_828_13777",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
export default SvgGeoIcon;
